export const GET_LEADS_DIVISIONS = 'GET_LEADS_DIVISIONS';
export const GET_LEADS_DIVISIONS_SUCCESS = 'GET_LEADS_DIVISIONS_SUCCESS';
export const GET_LEADS_DIVISIONS_FAILURE = 'GET_LEADS_DIVISIONS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/get_leads_divisions.constants.js